module.exports = __webpack_public_path__ + "static/media/180.7ba3b799.jpg";